import { createAction, props } from '@ngrx/store';

export const navigate = createAction(
    '[Navigation] navigate',
    props<{ url: string }>()
);

export const endNavigate = createAction(
    '[Navigation] end navigate'
);


export const lastUrlUnAccesible = createAction(
    '[Navigation]  last url unaccesible'
);

export const lastUrlAccesible = createAction(
    '[Navigation] last url accesible'
);

export const setSupportButton = createAction(
    '[Navigation] show support button',
    props<{value: boolean}>()
);
